import React, { lazy, Suspense } from 'react'
import LoadingComponent from 'components/generic/LoadingComponent'

const LazyComponent = lazy(() => import(/* webpackChunkName: "blog" */ './'))

export default function BlogLazy(props) {
  return (
    <Suspense fallback={<LoadingComponent />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}
